// Mappt den icon-String aus data/devices.js auf eine Lucide-Komponente.
// Fallback: Zap. So bekommt jedes Gerät ein eigenes Symbol.
import {
  Flame,
  Wind,
  Gamepad2,
  Refrigerator,
  Router,
  Snowflake,
  WashingMachine,
  UtensilsCrossed,
  AirVent,
  Fish,
  Tv,
  ChefHat,
  CupSoda,
  Coffee,
  Droplets,
  Fan,
  Microwave,
  Lightbulb,
  Monitor,
  Plug,
  Zap,
} from "lucide-react";

const MAP = {
  Flame,
  Wind,
  Gamepad2,
  Refrigerator,
  Router,
  Snowflake,
  WashingMachine,
  UtensilsCrossed,
  AirVent,
  Fish,
  Tv,
  ChefHat,
  CupSoda,
  Coffee,
  Droplets,
  Fan,
  Microwave,
  Lightbulb,
  Monitor,
  Plug,
};

export function DeviceIcon({ name, className }) {
  const Icon = MAP[name] || Zap;
  return <Icon className={className} />;
}
